module.exports = __webpack_public_path__ + "img/ktv-party_ms.65d29e41.jpg";